(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('ProjectTypeDetailController', ProjectTypeDetailController);

    ProjectTypeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'ProjectType', 'User'];

    function ProjectTypeDetailController($scope, $rootScope, $stateParams, previousState, entity, ProjectType, User) {
        var vm = this;

        vm.projectType = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('trakeyeApp:projectTypeUpdate', function(event, result) {
            vm.projectType = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
